module.exports = __webpack_public_path__ + "static/img/guitar-strat.405a0b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/guitar-strat.png
// module id = eFzn
// module chunks = 13